import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {AGENS_REDUCER_STATE_ID} from './agens_constants';
import {HaidiSchema} from 'src/js/common/types';

export interface AgensState {
  filterData: HaidiSchema.components['schemas']['HaiPathogenDto'][];
  isInitialized: boolean;
}

const initialState: AgensState = {
  filterData: [],
  isInitialized: false,
};

export interface AddAgensFilterDataPayload {
  filterData: HaidiSchema.components['schemas']['HaiPathogenDto'][];
}

export const agensSlice = createSlice({
  name: AGENS_REDUCER_STATE_ID,
  initialState,
  reducers: {
    addFilterData: (
      state,
      action: PayloadAction<AddAgensFilterDataPayload>
    ) => {
      state.filterData = action.payload.filterData;
      state.isInitialized = true;
    },
  },
});
